import React from "react";
import LayoutReader from "@bit/fabfitfun.shared.global.layout-reader";
import { getSpecData } from "../../../../utils/data";

class CMSContent extends React.PureComponent {
  state = {
    specData: null
  };

  componentDidMount() {
    getSpecData(this.props.id).then(specData => this.setState({ specData }));
  }

  render() {
    const { specData } = this.state;
    return (
      specData !== null && <LayoutReader {...this.props} specData={specData} />
    );
  }
}

export default CMSContent;



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/CMSContent/CMSContent.js